/* =====================================================
   HOPELESS MOPE — theme.js (Shopify edition)

   Wires:
     - Palette switcher (dev tool, optional)
     - Cart drawer ↔ Shopify cart API
     - Add-to-cart from product forms
     - Live quantity / remove inside drawer
     - Header cart badge
     - Free-shipping progress note
   ===================================================== */

(function(){
  'use strict';

  const SETTINGS = window.HM_SETTINGS || {};
  const ROUTES   = SETTINGS.routes || {};

  // ===== PALETTE SWITCHER ===========================
  const palettes = {
    cream:        {bg:'#f5eee0', ink:'#0a0a0a', mute:'#6a6a6a', accent:'#e63946'},
    bone:         {bg:'#e8e4d8', ink:'#0a0a0a', mute:'#6a6a6a', accent:'#e63946'},
    'white-pink': {bg:'#f4f3ee', ink:'#0a0a0a', mute:'#7a7a7a', accent:'#ff2d55'},
    'white-blue': {bg:'#f4f3ee', ink:'#0a0a0a', mute:'#7a7a7a', accent:'#2647ff'},
    black:        {bg:'#0a0a0a', ink:'#f0e9da', mute:'#888888', accent:'#e63946'}
  };

  function setPalette(name){
    const safeName = palettes[name] ? name : (SETTINGS.paletteDefault || 'white-pink');
    const p = palettes[safeName];
    const root = document.documentElement;
    Object.entries(p).forEach(([k,v]) => root.style.setProperty('--' + k, v));
    document.body.dataset.palette = safeName;
    document.querySelectorAll('#paletteSwitcher button').forEach(b =>
      b.classList.toggle('active', b.dataset.palette === safeName)
    );
    try { localStorage.setItem('hm-palette', safeName); } catch(e){}
  }

  function initPaletteSwitcher(){
    const switcher = document.getElementById('paletteSwitcher');
    if (!switcher) return;
    switcher.querySelectorAll('button').forEach(b =>
      b.addEventListener('click', () => setPalette(b.dataset.palette))
    );
  }

  // ===== CART HELPERS ===============================
  function formatMoney(cents){
    const fmt = SETTINGS.moneyFormat || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  async function fetchCart(){
    const r = await fetch(ROUTES.cart + '.js', { headers: { 'Accept': 'application/json' } });
    return r.json();
  }

  async function changeCartItem(key, quantity){
    const r = await fetch(ROUTES.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    return r.json();
  }

  async function addToCart(formData){
    const r = await fetch(ROUTES.cartAdd, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    });
    return r.json();
  }

  // Re-render drawer items list from a cart object
  function renderDrawer(cart){
    const itemsEl = document.getElementById('cartItems');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML =
        '<div class="cart-empty">' +
        '  <div class="icon">·_·</div>' +
        '  <p>your bag is empty.<br>add a feeling.</p>' +
        '  <a class="btn solid" href="' + (ROUTES.cart || '/cart') + '">browse the shop →</a>' +
        '</div>';
    } else {
      itemsEl.innerHTML = cart.items.map(item => (
        '<div class="cart-item" data-key="' + item.key + '">' +
        '  <a href="' + item.url + '" class="pic">' +
            (item.image
              ? '<img src="' + item.image + '" alt="' + (item.product_title || '') + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;border-radius:3px">'
              : '<span style="font-family:\'Space Mono\',monospace;font-size:9px;color:#888">img</span>') +
        '  </a>' +
        '  <div>' +
        '    <h4><a href="' + item.url + '" style="color:inherit;text-decoration:none">' + (item.product_title || '').toLowerCase() + '</a></h4>' +
        '    <div class="variant">' + (item.variant_title || '').toLowerCase() + '</div>' +
        '    <div class="qty" data-key="' + item.key + '">' +
        '      <button type="button" data-act="dec" aria-label="Decrease">−</button>' +
        '      <span>' + item.quantity + '</span>' +
        '      <button type="button" data-act="inc" aria-label="Increase">+</button>' +
        '    </div>' +
        '  </div>' +
        '  <div class="right">' +
        '    <div class="price">' + formatMoney(item.final_line_price) + '</div>' +
        '    <button type="button" class="remove" data-act="remove" data-key="' + item.key + '">remove</button>' +
        '  </div>' +
        '</div>'
      )).join('');
    }

    const countEl = document.getElementById('cartCount');
    const subEl   = document.getElementById('cartSubtotal');
    const totEl   = document.getElementById('cartTotal');
    const noteEl  = document.getElementById('cartNote');
    const badgeEl = document.getElementById('cartBadge');

    if (countEl) countEl.textContent = cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's');
    if (subEl)   subEl.textContent   = formatMoney(cart.items_subtotal_price);
    if (totEl)   totEl.textContent   = formatMoney(cart.total_price);
    if (badgeEl) badgeEl.textContent = cart.item_count;

    if (noteEl) {
      const threshold = (SETTINGS.freeShippingThreshold || 100) * 100;
      if (cart.total_price >= threshold) {
        noteEl.textContent = 'free shipping unlocked ★';
      } else {
        const remaining = threshold - cart.total_price;
        noteEl.textContent = 'free shipping at $' + (threshold / 100) + '. you\'re ' + formatMoney(remaining) + ' away.';
      }
    }
  }

  function openCart(){
    document.getElementById('cartDrawer')?.classList.add('open');
    document.getElementById('cartOverlay')?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart(){
    document.getElementById('cartDrawer')?.classList.remove('open');
    document.getElementById('cartOverlay')?.classList.remove('open');
    document.body.style.overflow = '';
  }

  function initCart(){
    const drawer = document.getElementById('cartDrawer');
    if (!drawer) return;

    document.querySelectorAll('[data-cart-trigger]').forEach(el => {
      el.addEventListener('click', e => {
        if (!SETTINGS.cartDrawerEnabled) return;
        e.preventDefault();
        openCart();
      });
    });

    document.getElementById('cartOverlay')?.addEventListener('click', closeCart);
    document.getElementById('cartClose')?.addEventListener('click', closeCart);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

    // Quantity + remove (event delegation)
    drawer.addEventListener('click', async e => {
      const act = e.target.dataset.act;
      if (!act) return;
      const itemEl = e.target.closest('.cart-item');
      if (!itemEl) return;
      const key = itemEl.dataset.key;
      const currentQty = parseInt(itemEl.querySelector('.qty span').textContent, 10) || 0;
      let newQty = currentQty;
      if (act === 'inc')    newQty = currentQty + 1;
      if (act === 'dec')    newQty = Math.max(0, currentQty - 1);
      if (act === 'remove') newQty = 0;
      const cart = await changeCartItem(key, newQty);
      renderDrawer(cart);
    });

    fetchCart().then(renderDrawer).catch(() => {});
  }

  // ===== ADD TO CART (PDP form) =====================
  function initAddToCart(){
    document.querySelectorAll('form[action$="/cart/add"]').forEach(form => {
      form.addEventListener('submit', async e => {
        if (!SETTINGS.cartDrawerEnabled) return;
        e.preventDefault();
        const submit = form.querySelector('[type="submit"]');
        const originalText = submit ? submit.innerHTML : '';
        if (submit) submit.innerHTML = '<span>adding...</span>';

        const fd = new FormData(form);
        try {
          const result = await addToCart(fd);
          if (result.status) {
            if (submit) submit.innerHTML = '<span>' + (result.description || 'error') + '</span>';
            return;
          }
          const cart = await fetchCart();
          renderDrawer(cart);
          openCart();
          if (submit) submit.innerHTML = '<span>added ✓</span><span class="price-suffix"></span>';
          setTimeout(() => { if (submit) submit.innerHTML = originalText; }, 1400);
        } catch (err) {
          if (submit) submit.innerHTML = originalText;
          console.error(err);
        }
      });
    });
  }

  // ===== PDP variant + thumb interactions ===========
  function initProductPage(){
    // Image thumbs (works regardless of product JSON)
    document.querySelectorAll('.pdp-thumb').forEach(t => {
      t.addEventListener('click', () => {
        document.querySelectorAll('.pdp-thumb').forEach(x => x.classList.remove('active'));
        t.classList.add('active');
        const main = document.getElementById('mainImgSrc');
        if (main && t.dataset.imgSrc) main.src = t.dataset.imgSrc;
      });
    });

    // Variant switching needs the product JSON injected by main-product.liquid
    const productJsonEl = document.getElementById('ProductJson');
    if (!productJsonEl) return;

    let product;
    try { product = JSON.parse(productJsonEl.textContent); } catch(e) { return; }

    const form = document.querySelector('form[action$="/cart/add"]');
    if (!form) return;
    const variantInput = form.querySelector('[name="id"]');

    // Track current selection by option position (1, 2, 3)
    const selected = {};
    document.querySelectorAll('.pdp-swatch.active, .pdp-size.active').forEach(b => {
      const pos = parseInt(b.dataset.optionPosition, 10);
      if (pos) selected[pos] = b.dataset.optionValue;
    });

    function findVariant(){
      return product.variants.find(v => {
        return Object.entries(selected).every(([pos, val]) => {
          return v['option' + pos] === val;
        });
      });
    }

    function updateForVariant(){
      const v = findVariant();

      // Update sold-out state for sizes based on currently selected color
      // (only relevant if there's both a color and a size option)
      document.querySelectorAll('.pdp-size').forEach(sizeBtn => {
        const sizePos = parseInt(sizeBtn.dataset.optionPosition, 10);
        const size = sizeBtn.dataset.optionValue;
        if (!sizePos || !size) return;
        const matchingVariant = product.variants.find(vv => {
          for (const [pos, val] of Object.entries(selected)) {
            if (parseInt(pos, 10) === sizePos) continue;
            if (vv['option' + pos] !== val) return false;
          }
          return vv['option' + sizePos] === size;
        });
        if (matchingVariant && matchingVariant.available) {
          sizeBtn.classList.remove('sold-out');
          sizeBtn.disabled = false;
          sizeBtn.removeAttribute('aria-disabled');
        } else {
          sizeBtn.classList.add('sold-out');
          sizeBtn.disabled = true;
          sizeBtn.setAttribute('aria-disabled', 'true');
        }
      });

      if (!v) {
        // Selected combination doesn't exist → disable add to bag
        const addBtn = form.querySelector('button[type="submit"]');
        if (addBtn) {
          addBtn.disabled = true;
          const labelSpan = addBtn.querySelector('span:not(.price-suffix)');
          if (labelSpan) labelSpan.textContent = 'unavailable';
        }
        return;
      }

      // Update hidden variant id
      if (variantInput) variantInput.value = v.id;

      // Update price display
      const priceEl = document.getElementById('pdpPrice');
      const priceSuffixEl = document.getElementById('pdpAddPrice');
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (priceSuffixEl) priceSuffixEl.textContent = formatMoney(v.price);

      // Update add-to-cart button availability
      const addBtn = form.querySelector('button[type="submit"]');
      if (addBtn) {
        const labelSpan = addBtn.querySelector('span:not(.price-suffix)');
        if (v.available) {
          addBtn.disabled = false;
          if (labelSpan) labelSpan.textContent = 'add to bag';
        } else {
          addBtn.disabled = true;
          if (labelSpan) labelSpan.textContent = 'sold out';
        }
      }

      // Update URL with variant param so deep links work
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }
    }

    // Wire option button clicks (only enabled ones)
    document.querySelectorAll('.pdp-swatch, .pdp-size').forEach(b => {
      b.addEventListener('click', e => {
        if (b.disabled || b.classList.contains('sold-out')) return;
        const pos = parseInt(b.dataset.optionPosition, 10);
        if (!pos) return;
        document.querySelectorAll('[data-option-position="' + pos + '"]').forEach(x => x.classList.remove('active'));
        b.classList.add('active');
        const labelEl = document.querySelector('[data-opt-' + pos + ']');
        if (labelEl) labelEl.textContent = b.dataset.optionValue.toLowerCase();
        selected[pos] = b.dataset.optionValue;
        updateForVariant();
      });
    });

    // Initial sync (handles ?variant=X URL params + sold-out states)
    updateForVariant();
  }

  // ===== MOBILE NAV DRAWER ==========================
  function initNavDrawer(){
    const toggle = document.querySelector('[data-nav-toggle]');
    const drawer = document.querySelector('[data-nav-drawer]');
    if (!toggle || !drawer) return;
    const closeBtn = drawer.querySelector('[data-nav-close]');

    function open(){
      drawer.hidden = false;
      requestAnimationFrame(() => drawer.classList.add('open'));
      toggle.setAttribute('aria-expanded','true');
      document.body.classList.add('nav-open');
    }
    function close(){
      drawer.classList.remove('open');
      toggle.setAttribute('aria-expanded','false');
      document.body.classList.remove('nav-open');
      setTimeout(() => { drawer.hidden = true; }, 250);
    }

    toggle.addEventListener('click', () => {
      drawer.classList.contains('open') ? close() : open();
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('open')) close();
    });
    // Close on link click (so anchor navigation feels right on mobile)
    drawer.querySelectorAll('a').forEach(a => a.addEventListener('click', close));
    // Close if window resized to desktop
    window.addEventListener('resize', () => {
      if (window.innerWidth > 900 && drawer.classList.contains('open')) close();
    });
  }

  // ===== PLP FILTER TOOLBAR =========================
  function initPlpFilters(){
    const form = document.getElementById('plpFilters');
    if (!form) return;

    // Submit (= navigate) on any filter change. Strip empty values
    // so the URL stays clean.
    function applyFilters(){
      const fd = new FormData(form);
      const params = new URLSearchParams();
      for (const [k,v] of fd.entries()){
        if (v !== '' && v != null) params.append(k, v);
      }
      const url = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      window.location.href = url;
    }

    // Color family masters toggle all their underlying value checkboxes,
    // then trigger applyFilters once. Other checkboxes apply directly.
    form.querySelectorAll('.color-family-master').forEach(master => {
      master.addEventListener('change', () => {
        const family = master.dataset.colorFamily;
        form.querySelectorAll('.color-family-value[data-color-family="' + family + '"]').forEach(v => {
          v.checked = master.checked;
        });
        applyFilters();
      });
    });
    form.querySelectorAll('input[type="checkbox"]:not(.color-family-master):not(.color-family-value)').forEach(cb => {
      cb.addEventListener('change', applyFilters);
    });
    const sort = form.querySelector('[data-sort-select]');
    if (sort) sort.addEventListener('change', applyFilters);

    form.querySelectorAll('input[type="number"]').forEach(input => {
      let t;
      input.addEventListener('input', () => {
        clearTimeout(t);
        t = setTimeout(applyFilters, 700);
      });
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter'){ e.preventDefault(); applyFilters(); }
      });
    });

    // Only one filter dropdown open at a time
    const groups = form.querySelectorAll('[data-filter-group]');
    groups.forEach(g => {
      g.addEventListener('toggle', () => {
        if (g.open){
          groups.forEach(other => { if (other !== g) other.open = false; });
        }
      });
    });
    // Close dropdowns when clicking outside
    document.addEventListener('click', (e) => {
      if (!form.contains(e.target)){
        groups.forEach(g => g.open = false);
      }
    });
    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') groups.forEach(g => g.open = false);
    });
  }

  // ===== HONEYPOT GUARD =============================
  // Any form containing a .hm-honeypot field gets a submit blocker:
  // if a bot fills the hidden honeypot input, the submit is canceled.
  function initHoneypot(){
    document.querySelectorAll('form').forEach(form => {
      const honey = form.querySelector('.hm-honeypot input');
      if (!honey) return;
      form.addEventListener('submit', (e) => {
        if ((honey.value || '').trim() !== '') {
          e.preventDefault();
          e.stopPropagation();
          // Silently no-op so attackers don't learn the trap exists.
        }
      }, true);
    });
  }

  // ===== INIT =======================================
  function init(){
    initPaletteSwitcher();
    initCart();
    initAddToCart();
    initProductPage();
    initNavDrawer();
    initPlpFilters();
    initHoneypot();

    let saved = SETTINGS.paletteDefault || 'white-pink';
    try {
      const stored = localStorage.getItem('hm-palette');
      if (stored && palettes[stored]) saved = stored;
    } catch(e){}
    setPalette(saved);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.HM = {
    openCart: openCart,
    closeCart: closeCart,
    setPalette: setPalette,
    refreshCart: () => fetchCart().then(renderDrawer)
  };
})();
